import Contact_us from "../contact_us/contact_us";
import Services from "../services/services";
import Topbar from "../topbar/topbar";
import Footer from "../Footer/Footer";
import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import img1 from "../../img/hcm1.jpg";
import FooterSec from "../footer_sec/footer_sec";
import ContactSection from "../contact/contact";
import VynHero from "../vyn_hero/vyn_hero";
import SeamlessOnboarding from "../features/seamless_onboard/seamless_onboard";
import ComplianceReconciliation from "../features/compliance_reconciliation/compliance_reconciliation";
import RealTime from "../features/real_time/real_time";
import DiscoverFeatures from "../discover_features/discover_features";

export default function VYNPage({openContactModal}) {
  const solutionsAndServicesRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    // Scroll to the solutionsAndServicesRef element if it exists
    if (solutionsAndServicesRef.current) {
      solutionsAndServicesRef.current.scrollIntoView({ behavior: "auto" });
    }
  }, [location]);

  const handleGoBack = () => {
    window.history.back(); // Go back in the browser's history
  };
  return (
    <div id="vyn_page">
      {/* <TopBar /> */}

      <Topbar />
      <VynHero />
      <SeamlessOnboarding />
      <ComplianceReconciliation />
      <RealTime />
      <DiscoverFeatures />

      <ContactSection openContactModal={openContactModal} />
      <FooterSec />
    </div>
  );
}
